export const truncateText=(source, size)=> {
    return source?.length > size ? source?.slice(0, size - 1) + "…" : source;
  }
  
//   var res = truncate('Truncate text to fit in 3 lines', 14);
